import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Upload,
  Select,
  Row,
  Col,
  message,
  Typography,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";

const { Option } = Select;
const { Title } = Typography;

const OwnersForm = ({ formData, setFormData, closeModal, refetchData }) => {
  const [form] = Form.useForm();
  const [idAttachmentFile, setIdAttachmentFile] = useState([]);
  const [imageAttachmentFile, setImageAttachmentFile] = useState([]);

  useEffect(() => {
    form.setFieldsValue(formData);
    if (formData.idAttachment) {
      setIdAttachmentFile([
        {
          uid: "-1",
          name: "Uploaded ID Attachment",
          status: "done",
          url: formData.idAttachment,
        },
      ]);
    }
    if (formData.imageAttachment) {
      setImageAttachmentFile([
        {
          uid: "-1",
          name: "Uploaded Image",
          status: "done",
          url: formData.imageAttachment,
        },
      ]);
    }
  }, [formData, form]);

  const handleIdAttachmentChange = ({ fileList }) =>
    setIdAttachmentFile(fileList);
  const handleImageAttachmentChange = ({ fileList }) =>
    setImageAttachmentFile(fileList);

  const onFinish = async (values) => {
    try {
      const formDataPayload = new FormData();

      // Append form data
      Object.keys(values).forEach((key) => {
        formDataPayload.append(key, values[key] || "");
      });

      // Append file data
      if (idAttachmentFile.length) {
        formDataPayload.append(
          "idAttachment",
          idAttachmentFile[0].originFileObj
        );
      }
      if (imageAttachmentFile.length) {
        formDataPayload.append(
          "imageAttachment",
          imageAttachmentFile[0].originFileObj
        );
      }

      if (formData.id) {
        // Update owner
        await axios.put(
          `http://93.127.203.113:5005/owners/${formData.id}`,
          formDataPayload,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      } else {
        // Create new owner
        await axios.post("http://93.127.203.113:5005/owners", formDataPayload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      message.success("Owner saved successfully");
      setFormData({});
      closeModal();
      refetchData(); // Trigger refetch after successful form submission
    } catch (error) {
      console.error("Error:", error);
      message.error("Failed to save owner");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <Row justify="start" style={{ marginBottom: "20px" }}>
        <Col>
          <Title level={4} style={{ color: "#0c8c49" }}>
            {formData.id ? "Edit Owner" : "Add Owner"}
          </Title>
        </Col>
      </Row>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: "Please enter the name" }]}
            >
              <Input placeholder="Enter owner's name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Contact"
              name="contact"
              rules={[
                { required: true, message: "Please enter the contact number" },
              ]}
            >
              <Input placeholder="Enter contact number" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Please enter the email" },
                { type: "email", message: "Please enter a valid email" },
              ]}
            >
              <Input placeholder="Enter email address" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Status" name="status">
              <Select placeholder="Select status">
                <Option value="Pending">Pending</Option>
                <Option value="Active">Active</Option>
                <Option value="Inactive">Inactive</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label="Address"
              name="address"
              rules={[
                { required: true, message: "Please enter the address" },
              ]}
            >
              <Input placeholder="Enter address" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Bank Info" name="bankInfo">
              <Input placeholder="Enter bank info (optional)" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item label="Upload ID Attachment">
              <Upload
                listType="picture"
                fileList={idAttachmentFile}
                onChange={handleIdAttachmentChange}
                beforeUpload={() => false}
              >
                <Button icon={<UploadOutlined />}>Upload ID Attachment</Button>
              </Upload>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Upload Owner Image">
              <Upload
                listType="picture"
                fileList={imageAttachmentFile}
                onChange={handleImageAttachmentChange}
                beforeUpload={() => false}
              >
                <Button icon={<UploadOutlined />}>Upload Owner Image</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        <Row justify="start" style={{ marginTop: "20px" }}>
          <Col>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                backgroundColor: "#0c8c49",
                borderColor: "#0c8c49",
                marginRight: "10px",
              }}
            >
              Save
            </Button>
            <Button
              htmlType="button"
              onClick={() => {
                form.resetFields();
                setIdAttachmentFile([]);
                setImageAttachmentFile([]);
              }}
            >
              Reset
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default OwnersForm;
